import { Inject, Injectable } from '@angular/core';
import { HttpXsrfTokenExtractor } from '@angular/common/http';
import type { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import type { Observable } from 'rxjs';

@Injectable()
export class RestXsrfInterceptor implements HttpInterceptor {

  constructor(@Inject(HttpXsrfTokenExtractor) private tokenExtractor: HttpXsrfTokenExtractor) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const headerName = 'X-XSRF-TOKEN';
    const token = this.tokenExtractor.getToken();
    if (token !== null && req.headers !== undefined && !req.headers.has(headerName)) {
      req = req.clone({ headers: req.headers.set(headerName, token) });
    }
    return next.handle(req);
  }

}
